import { t } from 'app/i18l'
import { useCompaniesContext } from 'company/context'
import { useGoldStarChanges } from 'gold_stars/queries/changes'
import { ViewGoldStarsTransactionsScreenProps } from 'home/stack/types'
import moment from 'moment'
import { useCallback, useLayoutEffect, useState } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { GoldStarChangesView } from './views'

export function ViewGoldStarsTransactionsScreen({
  navigation,
  route,
}: ViewGoldStarsTransactionsScreenProps) {
  const { activeCompany } = useCompaniesContext()

  const [currentDate, setCurrentDate] = useState<moment.Moment>(moment())

  const goldStarChangesQuery = useGoldStarChanges(
    activeCompany?.id,
    (currentDate.month() + 1).toString(),
    currentDate.year().toString()
  )

  useLayoutEffect(() => {
    showHeaderTitle(navigation, t('goldStarTransaction'))
  }, [navigation])

  const handlePrevMonth = useCallback(() => {
    setCurrentDate(prevDate => {
      const newDate = prevDate.clone()
      const currentMonth = moment()
      const twoMonthsAgo = currentMonth.clone().subtract(2, 'months')

      if (newDate.isAfter(twoMonthsAgo)) {
        return newDate.subtract(1, 'month')
      }
      return prevDate
    })
  }, [])

  const handleNextMonth = useCallback(() => {
    setCurrentDate(prevDate => {
      const newDate = prevDate.clone()
      const currentMonth = moment()

      if (newDate.isBefore(currentMonth, 'month')) {
        return newDate.add(1, 'month')
      }
      return prevDate
    })
  }, [])

  return (
    <StatusBoundary
      isLoading={goldStarChangesQuery.isLoading}
      error={goldStarChangesQuery.error}
    >
      <GoldStarChangesView
        goldStarChanges={goldStarChangesQuery?.data}
        currentDate={currentDate}
        onPrevMonth={handlePrevMonth}
        onNextMonth={handleNextMonth}
        canGoNext={!currentDate.isSame(moment(), 'month')}
        canGoPrev={currentDate.isAfter(moment().subtract(2, 'months'), 'month')}
      />
    </StatusBoundary>
  )
}
